module.exports = __webpack_public_path__ + "img/file-type-unknown.64803174.png";